import { render, staticRenderFns } from "./printRecordDetail.vue?vue&type=template&id=533acac3&scoped=true"
import script from "./printRecordDetail.vue?vue&type=script&lang=js"
export * from "./printRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./printRecordDetail.vue?vue&type=style&index=0&id=533acac3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533acac3",
  null
  
)

export default component.exports